import { getLabel } from "../../../../../hooks/use-labels";
import LinkText from "../../../../../components/LinkText";

import DetailPreview from "../../../../../components/Preview/DetailPreview";
import "./style.css";
import { useEffect, useState } from "react";

const SuccessfulCartView = ({ moveToCart }) => {
  const [hideView, setHideView] = useState(false);

  useEffect(() => {
    setTimeout(() => setHideView(true), 3000);
  });

  if (hideView) return null;

  return (
    <div className="successful-cart">
      <DetailPreview
        inlineFlex={true}
        className={"full-width font-14-regular-400-lh-22"}
        detailInfo={[
          {
            label: getLabel("addToCartSuccessMessage"),
            value: (
              <LinkText text={getLabel("viewCartLabel")} onClick={moveToCart} />
            ),
          },
        ]}
      />
    </div>
  );
};

export default SuccessfulCartView;
